"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeToolbarStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeToolbarStyles = function makeToolbarStyles(_ref) {
  var _objectSpread2;

  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiToolbar: {
      styleOverrides: {
        root: _objectSpread(_objectSpread(_objectSpread({}, tokens.effects["elevation-0-dropdown"]), tokens.typography["short-copy-medium"]), {}, (_objectSpread2 = {
          backgroundColor: tokens.colors["fill-primary"].rgb,
          borderRadius: primitives.borderRadii.large,
          color: tokens.colors["ink-on-fill-primary"].rgb,
          padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["4"]),
          boxSizing: "border-box",
          justifyContent: "space-between",
          minHeight: "calc(".concat(primitives.spacings["8"], " + ").concat(primitives.spacings["1"], ")"),
          '& [class*="MuiIconButton-root"]': {
            marginRight: primitives.spacings["2"]
          },
          '& button[class*="MuiButton-root"]': {
            backgroundColor: tokens.colors["fill-primary"].rgb,
            borderColor: tokens.colors["ink-on-fill-primary"].rgb,
            color: tokens.colors["ink-on-fill-primary"].rgb,
            whiteSpace: "nowrap"
          },
          '& button[class*="MuiButton-root"]:focus:active': {
            color: tokens.colors["ink-on-fill-primary"].rgb
          },
          '& [class*="MuiTypography-root"]': {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            marginRight: primitives.spacings["4"]
          }
        }, _defineProperty(_objectSpread2, "@media (min-width: 600px)", {
          padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["4"]),
          minHeight: "calc(".concat(primitives.spacings["8"], " + ").concat(primitives.spacings["1"], ")")
        }), _defineProperty(_objectSpread2, "@media (min-width: 0px) and (orientation: landscape)", {
          minHeight: "calc(".concat(primitives.spacings["8"], " + ").concat(primitives.spacings["1"], ")")
        }), _objectSpread2))
      }
    }
  };
};

exports.makeToolbarStyles = makeToolbarStyles;